import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export enum ControllerTab {
  TOURNAMENT = "TOURNAMENT",
  TIMER = "TIMER",
  SIT_IN = "SIT_IN",
  STATUS = "STATUS",
  PRIZE = "PRIZE",
}

export const useControllerTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab") as ControllerTab | null;

  // URL 쿼리에서 초기값 가져오기, 없으면 기본값 TOURNAMENT
  const getInitialTab = (): ControllerTab => {
    if (tabParam && Object.values(ControllerTab).includes(tabParam)) {
      return tabParam;
    }
    return ControllerTab.TOURNAMENT;
  };

  const [controllerTab, setControllerTabState] =
    useState<ControllerTab>(getInitialTab());

  // URL 쿼리 변경 시 탭 상태 동기화
  useEffect(() => {
    if (tabParam && Object.values(ControllerTab).includes(tabParam)) {
      const tabFromUrl = tabParam as ControllerTab;
      setControllerTabState(tabFromUrl);
    } else if (!tabParam) {
      // 쿼리가 없으면 기본값으로 설정
      setControllerTabState(ControllerTab.TOURNAMENT);
    }
  }, [tabParam]);

  const setControllerTab = (tab: ControllerTab) => {
    setControllerTabState(tab);
    // URL 쿼리 업데이트
    setSearchParams({ tab });
  };

  const isControllerTab = (tab: ControllerTab) => controllerTab === tab;

  return { controllerTab, setControllerTab, isControllerTab };
};
